module.exports = __webpack_public_path__ + "img/11-1.3e40b3c8.jpg";